import { getSetting, setSetting } from './settings/userSettings';
import { DIFFICULTY, type Difficulty } from './config/constants';

export type Locale = 'it' | 'en';

type Dict = {
  appTitle: string;
  appSubtitle: string;
  enterVR: string;
  loading: string;
  webxrNotSupported: string;
  openOnQuest: string;
  signInGoogle: string;
  signOut: string;
  signingIn: string;
  notSignedIn: string;
  signInError: string;
  userMenuResetSettings: string;
  userMenuDeleteAccount: string;
  menuButton: string;
  languageLabel: string;
  langItalian: string;
  langEnglish: string;
  confirmReset: string;
  confirmDeleteSessions: string;
  confirmDeleteAccount: string;
  confirmButton: string;
  cancel: string;
  accountWorking: string;
  accountError: string;
  appVersion: (v: string) => string;
  envLabel: string;
  envForest: string;
  envSalaDArmi: string;
  envPassthrough: string;
  heightDetected: (cm: number) => string;
  confirmHeight: string;
  squeezeTrigger: string;
  handDetectedRight: string;
  handDetectedLeft: string;
  handChangeHint: string;
  changeHand: string;
  durationLabel: string;
  duration30s: string;
  duration5: string;
  duration10: string;
  duration15: string;
  durationFree: string;
  clearPell: string;
  freeHits: (n: number) => string;
  settingsTitle: string;
  settingsHeight: (cm: number) => string;
  settingsPitch: (deg: number) => string;
  settingsYaw: (deg: number) => string;
  settingsRoll: (deg: number) => string;
  settingsHand: string;
  settingsHandRight: string;
  settingsHandLeft: string;
  settingsTurn: string;
  settingsClose: string;
  back: string;
  paused: string;
  resume: string;
  endSession: string;
  filoGood: string;
  filoOk: string;
  filoFlat: string;
  zoneHead: string;
  zoneShoulder: string;
  zoneChest: string;
  zoneFlank: string;
  zoneLeg: string;
  summaryTotal: string;
  summaryThrusts: string;
  summaryEdgeGood: string;
  summaryAvgVelocity: string;
  summaryCutRose: string;
  cutFendente: string;
  cutMontante: string;
  cutTondoDx: string;
  cutTondoSx: string;
  summaryStroke: string;
  strokeLato: string;
  strokeInclinazione: string;
  strokeFilo: string;
  strokeAmbiguoShort: string;
  latoMandritto: string;
  latoRiverso: string;
  incSgualembro: string;
  incTondo: string;
  incRidoppio: string;
  filoDritto: string;
  filoFalso: string;
  drillTypePrescriptive: string;
  drillTargetLabel: string;
  drillRepsLabel: string;
  optAny: string;
  next: string;
  drillNoteMatch: string;
  drillNoteAmbiguo: string;
  drillReasonZona: string;
  drillReasonLato: string;
  drillReasonInclinazione: string;
  drillReasonFilo: string;
  drillReasonPiattonata: string;
  summaryDrillTab: string;
  summaryDrillCorrect: string;
  summaryDrillAccuracy: string;
  summaryDrillTime: string;
  summaryDrillAvgEdge: string;
  summaryDrillReasons: string;
  reasonZona: string;
  reasonAmbiguo: string;
  summaryTabSummary: string;
  summaryTabTechnique: string;
  summaryRoseCaption: string;
  summaryRestart: string;
  summaryAgain: string;
  drillTypeLabel: string;
  drillTypePell: string;
  drillTypeTargets: string;
  drillTypeGuard: string;
  drillTypeArcade: string;
  drillTypeArcadeThrust: string;
  arcadeConfigLabel: string;
  arcadeTechniqueCut: string;
  arcadeTechniqueThrust: string;
  arcadeDurationTimed: string;
  arcadeDurationFree: string;
  difficultyEasy: string;
  difficultyMedium: string;
  difficultyHard: string;
  difficultyXhard: string;
  difficultyCustom: string;
  summaryDifficulty: string;
  summaryScore: string;
  summaryBest: string;
  summaryMaxCombo: string;
  summaryNewBest: string;
  hudArcadeScore: (n: number) => string;
  hudArcadeCombo: (mult: number, combo: number) => string;
  settingsArcadeTtl: (s: number) => string;
  settingsArcadeSpawnDelay: (s: number) => string;
  settingsArcadeCutTol: (deg: number) => string;
  settingsArcadeSize: (factor: number) => string;
  settingsArcadeMinSpeed: (mps: number) => string;
  settingsTargetTipMinT: (pct: number) => string;
  guardNone: string;
  guardPdfStretta: string;
  guardPdfLarga: string;
  guardClStretta: string;
  guardClAlta: string;
  guardClLarga: string;
  guardClDistesa: string;
  guardScopeLabel: string;
  guardScopeAll: string;
  guardScopeOne: string;
  guardPickLabel: string;
  guardSetStillHand: (v: number) => string;
  guardSetStillTip: (v: number) => string;
  guardSetDwell: (ms: number) => string;
  guardSetHandAlta: (pct: number) => string;
  guardSetAimVert: (cm: number) => string;
  guardSetAimCentro: (cm: number) => string;
  guardSetAimOnFig: (cm: number) => string;
  guardSetRollDown: (pct: number) => string;
  guardSetRollFlat: (pct: number) => string;
  targetsHudCount: (hits: number, total: number) => string;
  summaryHitRate: string;
  summaryAvgReaction: string;
  summaryAvgAccuracy: string;
  summaryZoneHitRate: string;
  settingsCancelSession: string;
  settingsTargetSize: (factor: number) => string;
  settingsMinSpeed: (mps: number) => string;
  settingsTabGeneral: string;
  settingsTabMode: string;
  settingsDistance: (m: number) => string;
  settingsTargetTtl: (s: number) => string;
  settingsTargetSpawnDelay: (s: number) => string;
  settingsZoneBand: (below: string, above: string, pct: number) => string;
  settingsZoneBandsTitle: string;
  settingsPellMinSpeed: (mps: number) => string;
  settingsPellMinArc: (m: number) => string;
  historyTitle: string;
  historyEmpty: string;
  historyExportAll: string;
  historyExportOne: string;
  historyTrends: string;
  historyDuration: string;
  historyManage: string;
  historyManageTitle: string;
  historyDeleteOne: string;
  historyDeleteAll: string;
  menuNickname: string;
  linkGoogle: string;
  anonymousNote: string;
  summaryTabLeaderboard: string;
  leaderboardLoading: string;
  leaderboardUnavailable: string;
  leaderboardEmpty: string;
  leaderboardPlayers: (n: number) => string;
  leaderboardTitle: string;
  leaderboardYourRank: (rank: number) => string;
  leaderboardRefresh: string;
  leaderboardTabCut: string;
  leaderboardTabThrust: string;
  leaderboardNicknameHint: string;
  audioSfxLabel: string;
  audioMusicLabel: string;
  settingsTabAudio: string;
  settingsSfxVolume: (pct: number) => string;
  settingsMusicVolume: (pct: number) => string;
};

const it: Dict = {
  appTitle: 'HEMA Trainer',
  appSubtitle: 'Pell trainer per scherma bolognese (Marozzo/Manciolino), spada sola.',
  enterVR: 'Entra in VR',
  loading: 'Caricamento…',
  webxrNotSupported: 'WebXR non supportato. Apri questa pagina dal browser di Meta Quest 3.',
  openOnQuest: 'Apri da Meta Quest 3.',
  signInGoogle: 'Accedi con Google',
  signOut: 'Esci',
  signingIn: 'Accesso in corso…',
  notSignedIn: 'Non connesso · impostazioni salvate solo su questo dispositivo',
  signInError: 'Accesso non riuscito',
  userMenuResetSettings: 'Svuota impostazioni',
  userMenuDeleteAccount: 'Elimina account',
  menuButton: 'Menù',
  languageLabel: 'Lingua',
  langItalian: 'Italiano',
  langEnglish: 'English',
  confirmReset: 'Ripristinare tutte le impostazioni ai valori predefiniti?',
  confirmDeleteSessions: 'Eliminare tutte le sessioni? L’operazione è irreversibile.',
  confirmDeleteAccount: 'Eliminazione definitiva. Scrivi la tua email per confermare:',
  confirmButton: 'Conferma',
  cancel: 'Annulla',
  accountWorking: 'Operazione in corso…',
  accountError: 'Operazione non riuscita',
  appVersion: (v) => `versione ${v}`,
  envLabel: 'Ambiente',
  envForest: 'Foresta',
  envSalaDArmi: "Sala d'armi",
  envPassthrough: 'Realtà',
  heightDetected: (cm) => `Altezza rilevata: ${cm} cm`,
  confirmHeight: 'Conferma altezza',
  squeezeTrigger: 'Premi il grilletto con la mano dominante',
  handDetectedRight: 'Mano destra rilevata',
  handDetectedLeft: 'Mano sinistra rilevata',
  handChangeHint:
    'Puoi cambiare mano e relative impostazioni premendo il tasto Y durante una sessione.',
  changeHand: 'Cambia mano',
  durationLabel: 'Durata sessione',
  duration30s: '30 s',
  duration5: '5 min',
  duration10: '10 min',
  duration15: '15 min',
  durationFree: 'Libera',
  clearPell: 'Svuota',
  freeHits: (n) => `${n} colpi`,
  settingsTitle: 'Impostazioni',
  settingsHeight: (cm) => `Altezza: ${cm} cm`,
  settingsPitch: (deg) => `Pitch (su/giù): ${deg}°`,
  settingsYaw: (deg) => `Yaw (sx/dx): ${deg}°`,
  settingsRoll: (deg) => `Roll (filo): ${deg}°`,
  settingsHand: 'Mano spada',
  settingsHandRight: 'Destra',
  settingsHandLeft: 'Sinistra',
  settingsTurn: 'Rotazione',
  settingsClose: 'Chiudi',
  back: 'Indietro',
  paused: 'PAUSA',
  resume: 'Riprendi',
  endSession: 'Termina sessione',
  filoGood: 'Filo buono',
  filoOk: 'Filo accettabile',
  filoFlat: 'Piattonata',
  zoneHead: 'testa',
  zoneShoulder: 'spalla',
  zoneChest: 'petto',
  zoneFlank: 'fianco',
  zoneLeg: 'gamba',
  summaryTotal: 'Colpi totali',
  summaryThrusts: 'Punte',
  summaryEdgeGood: '% filo buono',
  summaryAvgVelocity: 'Velocità media punta',
  summaryCutRose: 'Direzione colpi',
  cutFendente: 'fendente',
  cutMontante: 'montante',
  cutTondoDx: 'tondo dx',
  cutTondoSx: 'tondo sx',
  summaryStroke: 'Classificazione',
  strokeLato: 'Lato',
  strokeInclinazione: 'Inclinazione',
  strokeFilo: 'Filo',
  strokeAmbiguoShort: 'amb.',
  latoMandritto: 'mandritto',
  latoRiverso: 'riverso',
  incSgualembro: 'sgualembro',
  incTondo: 'tondo',
  incRidoppio: 'ridoppio',
  filoDritto: 'dritto',
  filoFalso: 'falso',
  drillTypePrescriptive: 'Drill',
  drillTargetLabel: 'Componi il colpo bersaglio',
  drillRepsLabel: 'Quante ripetizioni corrette',
  optAny: 'qualsiasi',
  next: 'Avanti',
  drillNoteMatch: '✓',
  drillNoteAmbiguo: '✗ non chiaro',
  drillReasonZona: '✗ zona',
  drillReasonLato: '✗ lato',
  drillReasonInclinazione: '✗ inclinazione',
  drillReasonFilo: '✗ filo',
  drillReasonPiattonata: '✗ piattonata',
  summaryDrillTab: 'Drill',
  summaryDrillCorrect: 'Corrette',
  summaryDrillAccuracy: 'Accuratezza',
  summaryDrillTime: 'Tempo',
  summaryDrillAvgEdge: 'Filo medio',
  summaryDrillReasons: 'Cause errore',
  reasonZona: 'Zona',
  reasonAmbiguo: 'Ambiguo',
  summaryTabSummary: 'Riepilogo',
  summaryTabTechnique: 'Tecnica',
  summaryRoseCaption: 'Direzione di moto della punta all’impatto',
  summaryRestart: 'Ripeti',
  summaryAgain: 'Altra sessione',
  drillTypeLabel: 'Tipo di esercizio',
  drillTypePell: 'Palo',
  drillTypeTargets: 'Bersagli',
  drillTypeGuard: 'Guardie',
  drillTypeArcade: 'Sfida',
  drillTypeArcadeThrust: 'Sfida punte',
  arcadeConfigLabel: 'Sfida',
  arcadeTechniqueCut: 'Tagli',
  arcadeTechniqueThrust: 'Punte',
  arcadeDurationTimed: 'Sfida 60s',
  arcadeDurationFree: 'Allenamento libero',
  difficultyEasy: 'Esercizio',
  difficultyMedium: 'Scontro',
  difficultyHard: 'Primo sangue',
  difficultyXhard: 'Mortale',
  difficultyCustom: 'Custom',
  summaryDifficulty: 'Difficoltà',
  summaryScore: 'Punteggio',
  summaryBest: 'Record',
  summaryMaxCombo: 'Combo massima',
  summaryNewBest: 'Nuovo record!',
  hudArcadeScore: (n) => `${n} pt`,
  hudArcadeCombo: (mult, combo) => `×${mult} · combo ${combo}`,
  settingsArcadeTtl: (s) => `Tempo scomparsa: ${s.toFixed(1)} s`,
  settingsArcadeSpawnDelay: (s) => `Tempo comparsa: ${s.toFixed(1)} s`,
  settingsArcadeCutTol: (deg) => `Toll. direzione: ${deg}°`,
  settingsArcadeSize: (factor) => `Dim. bersaglio: ${factor.toFixed(2)}×`,
  settingsArcadeMinSpeed: (mps) => `Vel. minima taglio: ${mps.toFixed(1)} m/s`,
  settingsTargetTipMinT: (pct) => `Punta minima: ${pct}%`,
  guardNone: 'fuori guardia',
  guardPdfStretta: 'Porta di ferro stretta',
  guardPdfLarga: 'Porta di ferro larga',
  guardClStretta: 'Coda lunga stretta',
  guardClAlta: 'Coda lunga alta',
  guardClLarga: 'Coda lunga larga',
  guardClDistesa: 'Coda lunga distesa',
  guardScopeLabel: 'Quali guardie provare?',
  guardScopeAll: 'Tutte',
  guardScopeOne: 'Una sola',
  guardPickLabel: 'Scegli la guardia',
  guardSetStillHand: (v) => `Mano ferma: ${v.toFixed(2)} m/s`,
  guardSetStillTip: (v) => `Punta ferma: ${v.toFixed(2)} m/s`,
  guardSetDwell: (ms) => `Attesa fermo: ${ms} ms`,
  guardSetHandAlta: (pct) => `Mano alta da: ${pct}%`,
  guardSetAimVert: (cm) => `Toll. occhi/cintola: ${cm} cm`,
  guardSetAimCentro: (cm) => `Zona morta centro: ${cm} cm`,
  guardSetAimOnFig: (cm) => `Mezza figura: ${cm} cm`,
  guardSetRollDown: (pct) => `Terza (filo giù): ${pct}%`,
  guardSetRollFlat: (pct) => `Seconda (filo piano): ${pct}%`,
  targetsHudCount: (hits, total) => `${hits}/${total}`,
  summaryHitRate: '% colpiti',
  summaryAvgReaction: 'Reazione media',
  summaryAvgAccuracy: 'Precisione media',
  summaryZoneHitRate: 'Colpiti per zona',
  settingsCancelSession: 'Annulla sessione',
  settingsTargetSize: (factor) => `Dim. bersaglio: ${factor.toFixed(2)}×`,
  settingsMinSpeed: (mps) => `Vel. minima punta: ${mps.toFixed(1)} m/s`,
  settingsTabGeneral: 'Generali',
  settingsTabMode: 'Modalità',
  settingsDistance: (m) => `Distanza: ${m.toFixed(1)} m`,
  settingsTargetTtl: (s) => `Tempo scomparsa: ${s.toFixed(1)} s`,
  settingsTargetSpawnDelay: (s) => `Tempo comparsa: ${s.toFixed(1)} s`,
  settingsZoneBand: (below, above, pct) => `${below}/${above}: ${pct}%`,
  settingsZoneBandsTitle: 'Zone del corpo (% altezza)',
  settingsPellMinSpeed: (mps) => `Vel. minima colpo: ${mps.toFixed(1)} m/s`,
  settingsPellMinArc: (m) => `Arco minimo colpo: ${m.toFixed(1)} m`,
  historyTitle: 'Storico sessioni',
  historyEmpty: 'Nessuna sessione ancora registrata.',
  historyExportAll: 'Esporta tutto (JSON)',
  historyExportOne: 'Esporta JSON',
  historyTrends: 'Andamento',
  historyDuration: 'Durata',
  historyManage: 'Gestisci sessioni',
  historyManageTitle: 'Gestione sessioni',
  historyDeleteOne: 'Elimina',
  historyDeleteAll: 'Elimina tutte',
  menuNickname: 'Nome in classifica',
  linkGoogle: 'Collega Google',
  anonymousNote: 'Profilo anonimo · collega Google per non perdere i punteggi',
  summaryTabLeaderboard: 'Classifica',
  leaderboardLoading: 'Caricamento classifica…',
  leaderboardUnavailable: 'Classifica non disponibile',
  leaderboardEmpty: 'Nessun punteggio ancora',
  leaderboardPlayers: (n) => `su ${n} giocatori`,
  leaderboardTitle: 'Classifica',
  leaderboardYourRank: (rank) => `La tua posizione: #${rank}`,
  leaderboardRefresh: 'Aggiorna',
  leaderboardTabCut: 'Tagli',
  leaderboardTabThrust: 'Punte',
  leaderboardNicknameHint: 'Il nuovo nome comparirà in classifica alla prossima partita.',
  audioSfxLabel: 'Volume suoni',
  audioMusicLabel: 'Volume musica',
  settingsTabAudio: 'Audio',
  settingsSfxVolume: (pct) => `Volume suoni: ${pct}%`,
  settingsMusicVolume: (pct) => `Volume musica: ${pct}%`,
};

// D'arte taxonomy (lato × inclinazione × filo and its values, cut-rose names, piattonata)
// stays Italian by design (DESIGN.md C3) — referenced from `it` so it can't drift.
const en: Dict = {
  appTitle: 'HEMA Trainer',
  appSubtitle: 'Pell trainer for Bolognese fencing (Marozzo/Manciolino), single sword.',
  enterVR: 'Enter VR',
  loading: 'Loading…',
  webxrNotSupported: 'WebXR not supported. Open this page in the Meta Quest 3 browser.',
  openOnQuest: 'Open on Meta Quest 3.',
  signInGoogle: 'Sign in with Google',
  signOut: 'Sign out',
  signingIn: 'Signing in…',
  notSignedIn: 'Not signed in · settings saved on this device only',
  signInError: 'Sign-in failed',
  userMenuResetSettings: 'Reset settings',
  userMenuDeleteAccount: 'Delete account',
  menuButton: 'Menu',
  languageLabel: 'Language',
  langItalian: 'Italiano',
  langEnglish: 'English',
  confirmReset: 'Reset all settings to their defaults?',
  confirmDeleteSessions: 'Delete all sessions? This cannot be undone.',
  confirmDeleteAccount: 'Permanent deletion. Type your email to confirm:',
  confirmButton: 'Confirm',
  cancel: 'Cancel',
  accountWorking: 'Working…',
  accountError: 'Operation failed',
  appVersion: (v) => `version ${v}`,
  envLabel: 'Environment',
  envForest: 'Forest',
  envSalaDArmi: it.envSalaDArmi, // sala d'armi (d'arte)
  envPassthrough: 'Reality',
  heightDetected: (cm) => `Detected height: ${cm} cm`,
  confirmHeight: 'Confirm height',
  squeezeTrigger: 'Squeeze the trigger with your dominant hand',
  handDetectedRight: 'Right hand detected',
  handDetectedLeft: 'Left hand detected',
  handChangeHint: 'Press the Y button during a session to change your hand and its settings.',
  changeHand: 'Change hand',
  durationLabel: 'Session duration',
  duration30s: '30 s',
  duration5: '5 min',
  duration10: '10 min',
  duration15: '15 min',
  durationFree: 'Free',
  clearPell: 'Clear',
  freeHits: (n) => `${n} hits`,
  settingsTitle: 'Settings',
  settingsHeight: (cm) => `Height: ${cm} cm`,
  settingsPitch: (deg) => `Pitch (up/down): ${deg}°`,
  settingsYaw: (deg) => `Yaw (L/R): ${deg}°`,
  settingsRoll: (deg) => `Roll (edge): ${deg}°`,
  settingsHand: 'Sword hand',
  settingsHandRight: 'Right',
  settingsHandLeft: 'Left',
  settingsTurn: 'Rotation',
  settingsClose: 'Close',
  back: 'Back',
  paused: 'PAUSED',
  resume: 'Resume',
  endSession: 'End session',
  filoGood: 'Good edge',
  filoOk: 'Acceptable edge',
  filoFlat: it.filoFlat, // piattonata (d'arte)
  zoneHead: 'head',
  zoneShoulder: 'shoulder',
  zoneChest: 'chest',
  zoneFlank: 'flank',
  zoneLeg: 'leg',
  summaryTotal: 'Total strikes',
  summaryThrusts: 'Thrusts',
  summaryEdgeGood: '% good edge',
  summaryAvgVelocity: 'Avg tip speed',
  summaryCutRose: 'Cut direction',
  cutFendente: it.cutFendente,
  cutMontante: it.cutMontante,
  cutTondoDx: 'tondo (R)',
  cutTondoSx: 'tondo (L)',
  summaryStroke: 'Classification',
  strokeLato: it.strokeLato,
  strokeInclinazione: it.strokeInclinazione,
  strokeFilo: it.strokeFilo,
  strokeAmbiguoShort: 'amb.',
  latoMandritto: it.latoMandritto,
  latoRiverso: it.latoRiverso,
  incSgualembro: it.incSgualembro,
  incTondo: it.incTondo,
  incRidoppio: it.incRidoppio,
  filoDritto: it.filoDritto,
  filoFalso: it.filoFalso,
  drillTypePrescriptive: 'Drill',
  drillTargetLabel: 'Build the target cut',
  drillRepsLabel: 'How many correct reps',
  optAny: 'any',
  next: 'Next',
  drillNoteMatch: '✓',
  drillNoteAmbiguo: '✗ unclear',
  drillReasonZona: '✗ zone',
  drillReasonLato: it.drillReasonLato,
  drillReasonInclinazione: it.drillReasonInclinazione,
  drillReasonFilo: it.drillReasonFilo,
  drillReasonPiattonata: it.drillReasonPiattonata,
  summaryDrillTab: 'Drill',
  summaryDrillCorrect: 'Correct',
  summaryDrillAccuracy: 'Accuracy',
  summaryDrillTime: 'Time',
  summaryDrillAvgEdge: 'Avg edge',
  summaryDrillReasons: 'Error causes',
  reasonZona: 'Zone',
  reasonAmbiguo: 'Ambiguous',
  summaryTabSummary: 'Summary',
  summaryTabTechnique: 'Technique',
  summaryRoseCaption: 'Tip motion direction at impact',
  summaryRestart: 'Repeat',
  summaryAgain: 'New session',
  drillTypeLabel: 'Exercise type',
  drillTypePell: 'Pell (palo)',
  drillTypeTargets: 'Targets',
  drillTypeGuard: 'Guards',
  drillTypeArcade: it.drillTypeArcade, // "Sfida" (d'arte name kept)
  drillTypeArcadeThrust: 'Sfida (thrusts)',
  arcadeConfigLabel: it.drillTypeArcade, // "Sfida"
  arcadeTechniqueCut: 'Cuts',
  arcadeTechniqueThrust: 'Thrusts',
  arcadeDurationTimed: 'Sfida 60s',
  arcadeDurationFree: 'Free practice',
  difficultyEasy: 'Exercise',
  difficultyMedium: 'Skirmish',
  difficultyHard: 'First Blood',
  difficultyXhard: 'Lethal',
  difficultyCustom: 'Custom',
  summaryDifficulty: 'Difficulty',
  summaryScore: 'Score',
  summaryBest: 'Best',
  summaryMaxCombo: 'Max combo',
  summaryNewBest: 'New best!',
  hudArcadeScore: (n) => `${n} pt`,
  hudArcadeCombo: (mult, combo) => `×${mult} · combo ${combo}`,
  settingsArcadeTtl: (s) => `Disappear time: ${s.toFixed(1)} s`,
  settingsArcadeSpawnDelay: (s) => `Appear time: ${s.toFixed(1)} s`,
  settingsArcadeCutTol: (deg) => `Direction tol.: ${deg}°`,
  settingsArcadeSize: (factor) => `Target size: ${factor.toFixed(2)}×`,
  settingsArcadeMinSpeed: (mps) => `Min cut speed: ${mps.toFixed(1)} m/s`,
  settingsTargetTipMinT: (pct) => `Min tip: ${pct}%`,
  guardNone: 'no guard',
  guardPdfStretta: it.guardPdfStretta, // d'arte
  guardPdfLarga: it.guardPdfLarga,
  guardClStretta: it.guardClStretta,
  guardClAlta: it.guardClAlta,
  guardClLarga: it.guardClLarga,
  guardClDistesa: it.guardClDistesa,
  guardScopeLabel: 'Which guards to practice?',
  guardScopeAll: 'All',
  guardScopeOne: 'Just one',
  guardPickLabel: 'Pick the guard',
  guardSetStillHand: (v) => `Hand still: ${v.toFixed(2)} m/s`,
  guardSetStillTip: (v) => `Tip still: ${v.toFixed(2)} m/s`,
  guardSetDwell: (ms) => `Settle time: ${ms} ms`,
  guardSetHandAlta: (pct) => `Hand high from: ${pct}%`,
  guardSetAimVert: (cm) => `Eyes/belt tol.: ${cm} cm`,
  guardSetAimCentro: (cm) => `Centre dead-band: ${cm} cm`,
  guardSetAimOnFig: (cm) => `Half-figure: ${cm} cm`,
  guardSetRollDown: (pct) => `Terza (edge down): ${pct}%`,
  guardSetRollFlat: (pct) => `Seconda (edge flat): ${pct}%`,
  targetsHudCount: (hits, total) => `${hits}/${total}`,
  summaryHitRate: '% hit',
  summaryAvgReaction: 'Avg reaction',
  summaryAvgAccuracy: 'Avg accuracy',
  summaryZoneHitRate: 'Hits by zone',
  settingsCancelSession: 'Cancel session',
  settingsTargetSize: (factor) => `Target size: ${factor.toFixed(2)}×`,
  settingsMinSpeed: (mps) => `Min tip speed: ${mps.toFixed(1)} m/s`,
  settingsTabGeneral: 'General',
  settingsTabMode: 'Mode',
  settingsDistance: (m) => `Distance: ${m.toFixed(1)} m`,
  settingsTargetTtl: (s) => `Disappear time: ${s.toFixed(1)} s`,
  settingsTargetSpawnDelay: (s) => `Appear time: ${s.toFixed(1)} s`,
  settingsZoneBand: (below, above, pct) => `${below}/${above}: ${pct}%`,
  settingsZoneBandsTitle: 'Body zones (% height)',
  settingsPellMinSpeed: (mps) => `Min cut speed: ${mps.toFixed(1)} m/s`,
  settingsPellMinArc: (m) => `Min cut arc: ${m.toFixed(1)} m`,
  historyTitle: 'Session history',
  historyEmpty: 'No sessions recorded yet.',
  historyExportAll: 'Export all (JSON)',
  historyExportOne: 'Export JSON',
  historyTrends: 'Trend',
  historyDuration: 'Duration',
  historyManage: 'Manage sessions',
  historyManageTitle: 'Session management',
  historyDeleteOne: 'Delete',
  historyDeleteAll: 'Delete all',
  menuNickname: 'Leaderboard name',
  linkGoogle: 'Link Google',
  anonymousNote: 'Anonymous profile · link Google so you don’t lose your scores',
  summaryTabLeaderboard: 'Leaderboard',
  leaderboardLoading: 'Loading leaderboard…',
  leaderboardUnavailable: 'Leaderboard unavailable',
  leaderboardEmpty: 'No scores yet',
  leaderboardPlayers: (n) => `of ${n} players`,
  leaderboardTitle: 'Leaderboard',
  leaderboardYourRank: (rank) => `Your rank: #${rank}`,
  leaderboardRefresh: 'Refresh',
  leaderboardTabCut: 'Cuts',
  leaderboardTabThrust: 'Thrusts',
  leaderboardNicknameHint: 'Your new name appears on the board after your next run.',
  audioSfxLabel: 'Sound volume',
  audioMusicLabel: 'Music volume',
  settingsTabAudio: 'Audio',
  settingsSfxVolume: (pct) => `Sound volume: ${pct}%`,
  settingsMusicVolume: (pct) => `Music volume: ${pct}%`,
};

const dict: Record<Locale, Dict> = { it, en };

function detectLocale(): Locale {
  const saved = getSetting('locale');
  if (saved === 'it' || saved === 'en') return saved;
  return navigator.language.toLowerCase().startsWith('it') ? 'it' : 'en';
}

let current: Locale = detectLocale();

export function t<K extends keyof Dict>(key: K): Dict[K] {
  return dict[current][key];
}

export function getLocale(): Locale {
  return current;
}

export function setLocale(loc: Locale): void {
  current = loc;
  setSetting('locale', loc);
}

/** Re-sync the active locale from the store (e.g. after a cloud settings pull). */
export function reloadLocale(): void {
  current = detectLocale();
}

/** Display label for a difficulty (the d'arte-themed names; #43). */
export function difficultyLabel(difficulty: Difficulty): string {
  switch (difficulty) {
    case DIFFICULTY.easy:
      return t('difficultyEasy');
    case DIFFICULTY.medium:
      return t('difficultyMedium');
    case DIFFICULTY.hard:
      return t('difficultyHard');
    case DIFFICULTY.xhard:
      return t('difficultyXhard');
    case DIFFICULTY.custom:
      return t('difficultyCustom');
  }
}
